// MetalStandingSeam recipe — Buildings Set1 §7.4: flat panels with periodic raised seams.
// Uses the new `standingSeam` primitive. A clean metal roof (rust-resistant grey/graphite).
// Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const METAL_STANDING_SEAM_RECIPE_ID = "metalStandingSeam";

export const metalStandingSeamRecipe = new MaterialRecipe({
	id: METAL_STANDING_SEAM_RECIPE_ID,
	name: "Metal standing seam",
	roughness: 0.35,
	specStrength: 0.5, // metal — a coherent highlight (roughness is low, so the lobe is tight)

	params: [
		new ParamSchema({key: "seam_spacing", label: "Seam spacing (m)", kind: "scalar", min: 0.2, max: 3, default: 0.6}),
		new ParamSchema({key: "seam_width", label: "Seam width (m)", kind: "scalar", min: 0.002, max: 0.05, default: 0.01}),
		new ParamSchema({key: "seam_height", label: "Seam height (m)", kind: "scalar", min: 0, max: 0.05, default: 0.015}),
		new ParamSchema({key: "panel_ramp", label: "Panel ramp", kind: "ramp", default: [0, 0.5, 0.5, 0.52, 1, 0.62, 0.62, 0.64]}),
		// Subtle broad sheen so a big flat metal roof isn't perfectly uniform.
		new ParamSchema({key: "sheen_ramp", label: "Sheen ramp", kind: "ramp", default: [0, 0.0, 0.0, 0.0, 1, 0.06, 0.06, 0.06]}),
	],
	layers: [
		new MaterialLayer({
			id: "seams",
			primitive: "standingSeam",
			args: {
				seamSpacing: {ref: "seam_spacing"},
				seamWidth: {ref: "seam_width"},
				seamHeight: {ref: "seam_height"},
				seamRamp: {ref: "panel_ramp"},
				sheenRamp: {ref: "sheen_ramp"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
